import axios from "axios";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import Cookies from "js-cookie";
import { FetchDataTypes } from "../../api/api";
import { Chart, ArcElement, Legend, Tooltip } from "chart.js";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { Grid, GridReadyEvent } from "ag-grid-community";
import "ag-grid-enterprise";
import { formateDataPrec } from "../../utils/types";

import "ag-grid-enterprise";
import { CsvExportModule } from "@ag-grid-community/csv-export";
import { ModuleRegistry } from "@ag-grid-community/core";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ExcelExportModule } from "@ag-grid-enterprise/excel-export";
import { MenuModule } from "@ag-grid-enterprise/menu";
import "react-tabs/style/react-tabs.css";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable, { UserOptions } from "jspdf-autotable";

Chart.register(ArcElement, Legend, Tooltip);

interface SAProps {
  title: string;
}
interface jsPDFCustom extends jsPDF {
  autoTable: (options: UserOptions) => void;
}

export interface IOlympicData {
  symbol: string;
  date: any;
  status: string;
  order: string;
  qty: string;
  price: number;
}

function FundPerformance({ title }: any) {
  const [FundPerformance, setFundPerformance] = useState<any>(null);
  const dataGridRefMain = useRef<AgGridReact<IOlympicData>>(null);
  const selectedClient: any = Cookies.get("client");
  const onGridReady = useCallback((params: GridReadyEvent) => {
    FetchDataTypes(
      "FundPerformance",
      parseInt(selectedClient),
      Cookies.get("newJwt")
    )
      .then((response) => response.json())
      .then((response) => {
        setFundPerformance(response);
      });
  }, []);

  const ColumnDefs = [
    {
      field: "fundName",
      headerName: "Fund Name",
      width: 200,
      resizable: true,
      cellClass: "cell-wrap-text",
      flex: 1,
    },
    {
      field: "mtdNet",
      headerName: "MTD",
      width: 120,
      cellClass: "cell-wrap-text textAlign",
      cellRenderer: formateDataPrec,
      headerClass: "headerTextAlign",
    },
    {
      field: "threeMonthsNet",
      headerName: "3M",
      cellRenderer: formateDataPrec,
      width: 120,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
    {
      field: "qtdNet",
      headerName: "6M",
      cellRenderer: formateDataPrec,
      width: 120,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
    {
      field: "ytdNet",
      headerName: "YTD",
      cellRenderer: formateDataPrec,
      width: 120,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
    {
      field: "oneYearNet",
      headerName: "1Y",
      cellRenderer: formateDataPrec,
      width: 120,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
    {
      field: "sinceInceptionNet",
      headerName: "ITD",
      cellRenderer: formateDataPrec,
      width: 120,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
  ];

  // const onBtExportMain = useCallback(() => {
  //   dataGridRefMain.current!.api.exportDataAsExcel();
  // }, []);

  const onBtExportMain = useCallback(() => {
    const params = {
      processCellCallback: (params: any) => {
        if (params.column.colId === "dateColumn") {
          // Format date as desired
          return params.value
            ? new Date(params.value).toLocaleDateString()
            : "";
        }
        if (typeof params.value === "string") {
          // Apply currency symbol to string values
          return `${params.value}`;
        }
        if (typeof params.value === "number") {
          // Format numbers as currency with the currency symbol
          return `${params.value.toFixed(2)}%`;
        }
        return params.value !== null ? `${params.value}%` : "--";
      },
    };

    dataGridRefMain.current?.api.exportDataAsExcel(params);
  }, []);

  const exportFundPerformanceData = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size) as jsPDFCustom;

    doc.setFontSize(8);

    const title = "Fund Performance";
    const headers = [["Fund Name", "MTD", "3M", "6M", "YTD", "1Y", "ITD"]];

    const data = FundPerformance.map((e: any) => [
      e.fundName,
      e.mtdNet !== null ? `${e.mtdNet}%` : "--",
      e.threeMonthsNet !== null ? `${e.threeMonthsNet}%` : "--",
      e.qtdNet !== null ? `${e.qtdNet}%` : "--",
      e.ytdNet !== null ? `${e.ytdNet}%` : "--",
      e.oneYearNet !== null ? `${e.oneYearNet}%` : "--",
      e.sinceInceptionNet !== null ? `${e.sinceInceptionNet}%` : "--",
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: data,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("FundPerformance.pdf");
  };

  const [gridHeight, setGridHeight] = useState("auto");
  const rowHeight = 30; // set the row height
  const rowCount = FundPerformance?.length; // get the row count

  useEffect(() => {
    const newHeight = `${rowHeight * rowCount + 140}px`; // calculate the grid height
    setGridHeight(newHeight); // set the grid height
  }, [rowCount]);

  return (
    <>
      <div className="card w-100">
        <div className="col-sm-3 w-100 d-flex pt-3 justify-content-between tableFilters px-4">
          <h5 className="card-title">{title ? title : "Fund Performance"}</h5>
          <div className="col-sm-2 my-3 text-end">
            <i
              className="align-middle me-2 far fa-fw fa-file-excel cursor-pointer"
              style={{ fontSize: "16px" }}
              onClick={onBtExportMain}
            ></i>
            <i
              className="align-middle me-2 far fa-fw fa-file-pdf cursor-pointer"
              onClick={() => exportFundPerformanceData()}
              style={{ fontSize: "16px" }}
            ></i>
          </div>
        </div>
        <div className="card-body">
          <div className="chart chart-xs">
            <div className="chartjs-size-monitor">
              <div className="chartjs-size-monitor-shrink">
                <div
                  className="ag-theme-alpine"
                  style={{
                    height: gridHeight,
                    width: "100%",
                    maxHeight: "550px",
                  }}
                >
                  <AgGridReact
                    ref={dataGridRefMain}
                    rowData={FundPerformance}
                    columnDefs={ColumnDefs}
                    onGridReady={onGridReady}
                    pagination={true}
                    paginationPageSize={20}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export { FundPerformance };
